import { createAction } from '@reduxjs/toolkit'

/**
 * Команды инвентаризации — plain actions (F05): экран вызывает actions
 * binding-а, binding dispatch-ит команду, listener исполняет её через порты.
 * rid и склад — в каждой команде: listener не берёт базу из «выбранного
 * ресурса» (D-064).
 */
interface SessionRef {
  resourceId: string
  warehouseRefKey: string
}

export const inventoryScanRequested = createAction<SessionRef & { barcode: string }>('onec/inventory/scanRequested')

/** Сохранить дельту сейчас (автосохранение по паузе или кнопка «Сохранить ещё раз»). */
export const inventorySaveRequested = createAction<SessionRef>('onec/inventory/saveRequested')

export const inventoryCreateRequested = createAction<
  SessionRef & {
    rowId: string
    name: string
    barcode: string
    prices: readonly { warehouseRefKey: string; price: number }[]
  }
>('onec/inventory/createRequested')

export const inventoryClearRequested = createAction<SessionRef>('onec/inventory/clearRequested')

/** Отправить ТУ ЖЕ команду ещё раз тем же ключом: проверка неизвестного исхода. */
export const inventoryOperationResendRequested = createAction<{ key: string }>('onec/inventory/resendRequested')

/** Перечитать сессию склада (`warehouseRefKey`) или справочник складов (`null`). */
export const inventoryReloadRequested = createAction<{ resourceId: string; warehouseRefKey: string | null }>(
  'onec/inventory/reloadRequested',
)
